// src/lib/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// HOTFIX: usamos valores directos para evitar problemas de .env en el build
const SUPABASE_URL = 'https://lzttlidnkmoqiaqodmtr.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx6dHRsaWRua21vcWlhcW9kbXRyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ2OTAxMTYsImV4cCI6MjA3MDI2NjExNn0.-SVpzRnY1QPK4SFT7hIWAppF_wrumHqxggZ4yaFwt4o';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
